/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PurchaseCancelReqVo,
  ResponsePurchaseCancelInfoVo,
  ResponseString,
} from '../models/index';
import {
    PurchaseCancelReqVoFromJSON,
    PurchaseCancelReqVoToJSON,
    ResponsePurchaseCancelInfoVoFromJSON,
    ResponsePurchaseCancelInfoVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface PurchaseCancelAddOrUpdatePostRequest {
    purchaseCancelReqVo?: PurchaseCancelReqVo;
}

export interface PurchaseCancelPurchaseCancelInfoOrderIdGetRequest {
    orderId: number;
}

/**
 * 
 */
export class PurchaseCancelControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 创建采购取消申请
     */
    async purchaseCancelAddOrUpdatePostRaw(requestParameters: PurchaseCancelAddOrUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/purchase-cancel/addOrUpdate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseCancelReqVoToJSON(requestParameters['purchaseCancelReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 创建采购取消申请
     */
    async purchaseCancelAddOrUpdatePost(requestParameters: PurchaseCancelAddOrUpdatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.purchaseCancelAddOrUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取采购取消申请信息
     */
    async purchaseCancelPurchaseCancelInfoOrderIdGetRaw(requestParameters: PurchaseCancelPurchaseCancelInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePurchaseCancelInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling purchaseCancelPurchaseCancelInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/purchase-cancel/purchaseCancelInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePurchaseCancelInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取采购取消申请信息
     */
    async purchaseCancelPurchaseCancelInfoOrderIdGet(requestParameters: PurchaseCancelPurchaseCancelInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePurchaseCancelInfoVo> {
        const response = await this.purchaseCancelPurchaseCancelInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
